// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"8120":"366ccb1a","8688":"3f30ccb1"}[chunkId] + ".chunk.css");